import { render, staticRenderFns } from "./Ikigai.vue?vue&type=template&id=10c3b9ec&scoped=true&"
import script from "./Ikigai.vue?vue&type=script&lang=js&"
export * from "./Ikigai.vue?vue&type=script&lang=js&"
import style0 from "./Ikigai.vue?vue&type=style&index=0&id=10c3b9ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c3b9ec",
  null
  
)

export default component.exports